module.exports = __webpack_public_path__ + "img/danger.4f6322a0.png";